const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
const VIDEO_EXTENSIONS = ["mp4", "avi", "mov", "mkv", "webm", "wmv"];

export const getFileExtension = (url: string) =>
  url.split(".").pop()?.split("?")[0]?.toLowerCase() || "";

export const isImageUrl = (url: string) =>
  IMAGE_EXTENSIONS.includes(getFileExtension(url));

export const isVideoUrl = (url: string) =>
  VIDEO_EXTENSIONS.includes(getFileExtension(url));

export const isMediaUrl = (url: string) => isImageUrl(url) || isVideoUrl(url);

export const getFileName = (url: string) => {
  const name = url.split("/").pop()?.split("?")[0] || "file";
  try {
    return decodeURIComponent(name);
  } catch (error) {
    return name;
  }
};

const EXTENSION_BADGE_COLORS: Record<string, string> = {
  pdf: "#F44336",
  doc: "#2196F3",
  docx: "#2196F3",
  xls: "#4CAF50",
  xlsx: "#4CAF50",
  zip: "#9E9E9E",
  rar: "#9E9E9E",
  "7z": "#9E9E9E",
  txt: "#2196F3",
  json: "#9E9E9E",
  csv: "#4CAF50",
  ppt: "#FF9800",
  pptx: "#FF9800",
  mp3: "#9C27B0",
  wav: "#9C27B0",
  mp4: "#2196F3",
  avi: "#2196F3",
  mov: "#2196F3",
  jpg: "#2196F3",
  jpeg: "#2196F3",
  png: "#2196F3",
  gif: "#2196F3",
  svg: "#2196F3",
  webp: "#2196F3",
};

export const getBadgeColor = (url: string): string => {
  const ext = getFileExtension(url);
  return EXTENSION_BADGE_COLORS[ext] || "#9E9E9E";
};
